import { Badge, Tooltip, cn } from '@skupreme/shared/ui';
import { DateFormat, DateUtility } from '@utility/date';
import type { PastSla } from '../../lib/past-sla';
import { PAST_SLA_LABEL } from '../../lib/past-sla';

export type PastSlaBadgeProps = {
  pastSla: PastSla | undefined;
  /** The list row's chip size; the detail card uses the default badge. */
  compact?: boolean;
  className?: string;
};

/**
 * A warning, not an issue: the order keeps its status and tab, and nothing
 * was changed on it. It goes away with the provider's next update.
 */
export function PastSlaBadge({
  pastSla,
  compact,
  className,
}: PastSlaBadgeProps) {
  if (!pastSla) {
    return null;
  }

  const flaggedAt = DateUtility.formatDate(
    pastSla.since,
    DateFormat.meridianTimeDate,
  );

  return (
    <Tooltip
      placement="bottom start"
      content={`The fulfillment provider has not updated this order since its handling deadline (flagged ${flaggedAt}). Nothing was changed; the order stays where it is.`}
    >
      <span className={cn('sk:inline-flex sk:cursor-default', className)}>
        <Badge
          tone="caution"
          className={cn(compact && 'sk:text-xs sk:font-normal')}
        >
          {PAST_SLA_LABEL}
        </Badge>
      </span>
    </Tooltip>
  );
}
